import { render, staticRenderFns } from "./DiscountCustomerGroups.vue?vue&type=template&id=6d1e80de&scoped=true&"
import script from "./DiscountCustomerGroups.vue?vue&type=script&lang=js&"
export * from "./DiscountCustomerGroups.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCustomerGroups.vue?vue&type=style&index=0&id=6d1e80de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e80de",
  null
  
)

export default component.exports